// ============================================================================
// HEBREW TRANSLATIONS - CHAPTER 2: שמות
// ============================================================================
// רמות 14-26 (13 רמות, 39 שאלות)

export const chapter2Translations = {
  name: "שמות",
  description: "שחרור עם האלוהים... להכיר את האלוהים משנה את חיינו",
  
  spiritualWisdom: {
    principle: "הכרת האלוהים משחררת ומשנה",
    scripture: "ותדעו את האמת, והאמת תשחרר אתכם (יוחנן 8:32)",
    application: "כפי שישראל שוחרר ממצרים, הכרת האלוהים משחררת אותנו מעבדות רוחנית"
  },
  
  levels: {
    14: {
      name: "משה ניצל מן המים",
      challenge: "ותהר האשה ותלד בן. ותרא אותו כי טוב הוא...",
      easy: {
        question: "במה הסתירה אם משה את בנה?",
        options: ["מערה", "תיבת גומא", "סל", "בית"],
        hint: "כלי זה צף על הנילוס",
        funFact: "🏺 תיבת הגומא הייתה מצופה בזפת כדי להיות אטומה למים!"
      },
      medium: {
        question: "מי מצא את משה בין הסוף?",
        options: [
          "בת פרעה",
          "משרתת מצרית",
          "אחותו מרים",
          "כהן מצרי"
        ],
        hint: "חבר במשפחת המלוכה המצרית",
        funFact: "👑 באירוניה, משפחת פרעה היא שמצילה את מי שיאתגר אותו!"
      },
      hard: {
        question: "כיצד ההשגחה האלוהית משתמשת אפילו באויבינו?",
        options: [
          "על ידי המרתם",
          "על ידי תזמור הנסיבות כדי להגשים את כוונותיה",
          "על ידי עונש",
          "על ידי התעלמות"
        ],
        hint: "מדובר בלראות את יד האלוהים באירועים",
        funFact: "✨ משה גדל בארמון של מי שדיכא את עמו!"
      }
    },
    
    15: {
      name: "הסנה הבוער",
      challenge: "וירא מלאך ה' אליו בלבת אש מתוך הסנה...",
      easy: {
        question: "מה היה על משה להסיר לפני הסנה הבוער?",
        options: ["תכשיטיו", "נעליו", "גלימתו", "טורבנו"],
        hint: "מה שעוטים על הרגליים",
        funFact: "👡 חליצת נעליים מבטאת כבוד על אדמה קדושה!"
      },
      medium: {
        question: "איזה שם אלוהים מגלה למשה?",
        options: [
          "ה'",
          "אהיה אשר אהיה",
          "אל שדי",
          "הבורא"
        ],
        hint: "שם המבטא קיום מוחלט",
        funFact: "🔥 יהוה (אני הוא) מגלה את מהותו הנצחית של אלוהים!"
      },
      hard: {
        question: "מה מלמד אותנו הסנה הבוער שאינו נשרף?",
        options: [
          "קסם קיים",
          "אלוהים מתעלה על חוקי הטבע",
          "אש היא קדושה",
          "צמחים הם קסומים"
        ],
        hint: "מדובר בטבע האלוהי העולה על הבנתנו",
        funFact: "🌿 הסנה מסמל שהנוכחות האלוהית מקדשת מבלי להרוס!"
      }
    },

    16: {
      name: "עשר מכות מצרים",
      challenge: "ויחזק פרעה את לבו ולא שמע אליהם...",
      easy: {
        question: "מה הייתה המכה הראשונה של מצרים?",
        options: ["הצפרדעים", "המים שהפכו לדם", "הערוב", "הכינים"],
        hint: "היא פגעה בנילוס, מקור החיים למצרים",
        funFact: "🩸 הנילוס נחשב לאל, ואלוהים הראה את עליונותו!"
      },
      medium: {
        question: "מה הייתה המכה האחרונה והנוראה ביותר?",
        options: [
          "הברד",
          "החושך",
          "מכת בכורות",
          "הארבה"
        ],
        hint: "המכה הזו פגעה ישירות במשפחות",
        funFact: "😢 המכה הזו שברה סוף סוף את גאוות פרעה ושחררה את ישראל!"
      },
      hard: {
        question: "מדוע אלוהים מחזק את לב פרעה?",
        options: [
          "כדי להעניש אותו",
          "כדי להראות את כבודו ועוצמתו",
          "מרשעות",
          "כדי להאריך את הסבל"
        ],
        hint: "מדובר בגילוי מי הוא האל האמיתי",
        funFact: "⚡ המכות מוכיחות שיהוה חזק יותר מכל אלוהי מצרים!"
      }
    },

    17: {
      name: "הפסח",
      challenge: "קחו לכם שה... ונתנו מדמו על המשקוף...",
      easy: {
        question: "היכן צריכים היו בני ישראל לשים את דם השה?",
        options: [
          "על בגדיהם",
          "על משקופי ומזוזות הדלתות",
          "על מצחם",
          "בכוסות"
        ],
        hint: "בכניסה לבתיהם",
        funFact: "🩸 הדם על הדלת היה סימן להגנה האלוהית!"
      },
      medium: {
        question: "כיצד היו צריכים לאכול את שה הפסח?",
        options: [
          "יושבים בנוחות",
          "רק במשפחה",
          "מתניהם חגורים, נעלים ברגליהם, מקל בידם",
          "בשתיקה"
        ],
        hint: "מוכנים ליציאה",
        funFact: "🚶 היו צריכים להיות מוכנים לצאת במהירות לחירות!"
      },
      hard: {
        question: "כיצד שה הפסח מסמל את המשיח?",
        options: [
          "בלובנו",
          "בקרבן התחליפי שלו המציל מן המוות",
          "בענוותנותו",
          "בגילו"
        ],
        hint: "מדובר בקרבן המציל מן הדין",
        funFact: "🐑 ישוע נקרא 'שה האלוהים הנושא את חטא העולם'!"
      }
    },

    18: {
      name: "חציית ים סוף",
      challenge: "ויט משה את ידו על הים...",
      easy: {
        question: "כיצד חצו בני ישראל את הים?",
        options: [
          "בסירה",
          "בשחייה",
          "ביבשה",
          "על רפסודה"
        ],
        hint: "קרקעית הים הייתה ראויה להליכה",
        funFact: "🌊 אלוהים הפך מכשול לדרך שחרור!"
      },
      medium: {
        question: "מה קרה למצרים שרדפו?",
        options: [
          "חזרו לאחור",
          "נבלעו במים",
          "תעו",
          "הצטרפו לישראל"
        ],
        hint: "המים שבו עליהם",
        funFact: "⚔️ הצבא החזק בעולם נהרס ברגע!"
      },
      hard: {
        question: "מה מסמלת החציה הזו בחיינו הרוחניים?",
        options: [
          "בריחה מבעיות",
          "המעבר מעבדות החטא לחירות באלוהים",
          "עליונות ישראל",
          "השמדת האויבים"
        ],
        hint: "מדובר בשינוי רוחני",
        funFact: "🗽 ים סוף מייצג את הטבילה: מוות לישן, חיים חדשים!"
      }
    },

    19: {
      name: "המן במדבר",
      challenge: "מה זה? כי לא ידעו מה הוא...",
      easy: {
        question: "כמה זמן ירד המן?",
        options: ["10 שנים", "20 שנה", "40 שנה", "50 שנה"],
        hint: "אותו מספר כמו השנים במדבר",
        funFact: "🍞 במשך 40 שנה, אלוהים האכיל בנס 2 מיליון אנשים!"
      },
      medium: {
        question: "מה קרה אם שמרו את המן יותר מיום אחד?",
        options: [
          "נעשה טעים יותר",
          "התרבה",
          "התקלקל והסריח",
          "התקשה"
        ],
        hint: "למעט ביום שישי לשבת",
        funFact: "🪱 אלוהים לימד בכך תלות יומית בו!"
      },
      hard: {
        question: "כיצד המן מלמד אותנו אמון?",
        options: [
          "באגירה לעתיד",
          "בהסתמכות על השגחת אלוהים היומית",
          "בעבודה קשה יותר",
          "בשיתוף שווה"
        ],
        hint: "מדובר באמון יום יום",
        funFact: "🙏 'את לחם חוקנו תן לנו היום' בא מהחוויה הזו!"
      }
    },

    20: {
      name: "המים מהסלע",
      challenge: "תכה את הסלע, ויצאו ממנו מים...",
      easy: {
        question: "במה היה על משה להכות את הסלע?",
        options: ["ידו", "מטהו", "אבן", "פטיש"],
        hint: "כלי הניסים של משה",
        funFact: "⚡ מטה משה היה כלי הכוח האלוהי!"
      },
      medium: {
        question: "למה העם התלונן נגד משה?",
        options: [
          "לא היה מים לשתות",
          "חסר היה אוכל",
          "הדרך הייתה ארוכה מדי",
          "היה חם מדי"
        ],
        hint: "צורך חיוני במדבר",
        funFact: "💧 מים חיוניים יותר מאוכל להישרדות!"
      },
      hard: {
        question: "מה מייצגים המים מהסלע רוחנית?",
        options: [
          "משאבים טבעיים",
          "החיים הרוחניים הנובעים מהמשיח, הסלע",
          "פרס על מאמצים",
          "קסם אלוהי"
        ],
        hint: "פאולוס אומר שהסלע הזה היה המשיח",
        funFact: "🗿 המשיח הוא הסלע המוכה שממנו נובעים החיים הנצחיים!"
      }
    },

    21: {
      name: "הר סיני",
      challenge: "וכל הר סיני עישן, כי ירד ה' עליו...",
      easy: {
        question: "כמה מצוות נתן אלוהים?",
        options: ["5", "7", "10", "12"],
        hint: "מספר עגול ומושלם",
        funFact: "📜 עשרת הדברות הם היסוד המוסרי של האנושות!"
      },
      medium: {
        question: "על מה נכתבו המצוות?",
        options: [
          "פפירוס",
          "קלף",
          "שני לוחות אבן",
          "ארד"
        ],
        hint: "חומר עמיד שנכתב באצבע אלוהים",
        funFact: "✍️ נכתבו על ידי אלוהים עצמו כדי להראות את חשיבותם הנצחית!"
      },
      hard: {
        question: "מה המטרה של המצוות האלוהיות?",
        options: [
          "להעניש אנשים",
          "לגלות את קדושת אלוהים ולהוביל לאושר",
          "ליצור כללים מסובכים",
          "להפריד בין עמים"
        ],
        hint: "מדובר בגילוי האופי האלוהי ודרך הטוב",
        funFact: "⚖️ המצוות מגלות אהבה: אהבת אלוהים ואהבת הזולת!"
      }
    },

    22: {
      name: "עגל הזהב",
      challenge: "עשה לנו אלוהים אשר ילכו לפנינו...",
      easy: {
        question: "ממה עשה אהרון את עגל הזהב?",
        options: [
          "מטבעות זהב",
          "עגילי הזהב של העם",
          "תכשיטים יקרים",
          "זהב מהמדבר"
        ],
        hint: "תכשיטים אישיים שניתנו על ידי העם",
        funFact: "👂 העם נתן את תכשיטיו כדי ליצור את הפסל שלו!"
      },
      medium: {
        question: "מה הייתה תגובת משה כשראה את העגל?",
        options: [
          "הוא בכה",
          "הוא התפלל",
          "הוא שבר את לוחות הברית",
          "הוא רק כעס"
        ],
        hint: "מחווה סמלית של הברית השבורה",
        funFact: "💥 שבירת הלוחות סימלה שהברית נשברה!"
      },
      hard: {
        question: "למה עבודה זרה כל כך מסוכנת רוחנית?",
        options: [
          "היא יקרה",
          "היא מפנה את הלב מהאל האמיתי אל היצורים",
          "היא מפצלת משפחות",
          "היא אסורה"
        ],
        hint: "מדובר במתן ליצור מה ששייך לבורא",
        funFact: "💔 עבודה זרה שוברת את הקשר הבלעדי עם האל החי!"
      }
    },

    23: {
      name: "המשכן",
      challenge: "ועשו לי מקדש, ושכנתי בתוכם...",
      easy: {
        question: "איך קראו לאוהל הקדוש של בני ישראל?",
        options: ["המקדש", "המשכן", "הקודש", "הארון"],
        hint: "השם משמעותו 'אוהל מועד'",
        funFact: "⛺ המשכן היה 'הבית הנייד' של אלוהים עם עמו!"
      },
      medium: {
        question: "מה הכיל ארון הברית?",
        options: [
          "תכשיטי הכהן הגדול",
          "לוחות הברית, המן, מטה אהרון",
          "חתיכות זהב",
          "מגילות התורה"
        ],
        hint: "שלושה פריטים המסמלים את הברית עם אלוהים",
        funFact: "📦 הארון הכיל את 'הזיכרונות' של נאמנות אלוהית!"
      },
      hard: {
        question: "מה מסמל המשכן ביחסינו עם אלוהים?",
        options: [
          "בניין דתי",
          "נוכחות אלוהים השוכנת בינינו ובתוכנו",
          "מקום קרבן בלבד",
          "סמל לאומי"
        ],
        hint: "מדובר בנוכחות האלוהית הנגישה",
        funFact: "🏠 'גופכם הוא היכל רוח הקודש' לפי פאולוס!"
      }
    },

    24: {
      name: "הכהן הגדול אהרון",
      challenge: "וקדשת את אהרון ואת בניו להיות לי כהנים...",
      easy: {
        question: "מי היה הכהן הגדול הראשון של ישראל?",
        options: ["משה", "אהרון", "יהושע", "אלעזר"],
        hint: "אחיו של משה",
        funFact: "👨‍⚕️ אהרון ייסד את השושלת הכהנית שנמשכה יותר מ-1000 שנה!"
      },
      medium: {
        question: "מה נשא הכהן הגדול על חזהו?",
        options: [
          "צלב זהב",
          "החושן עם שתים עשרה האבנים היקרות",
          "מדליון",
          "שרשרת זהב"
        ],
        hint: "שתים עשרה אבנים המייצגות את שנים עשר השבטים",
        funFact: "💎 הכהן הגדול נשא באופן סמלי את כל ישראל על לבו!"
      },
      hard: {
        question: "כיצד ישוע ממלא את תפקיד הכהן הגדול?",
        options: [
          "על ידי לבישת בגדים קדושים",
          "על ידי הקרבת דמו פעם אחת ולתמיד",
          "על ידי שירות במקדש",
          "על ידי היותו צאצא של אהרון"
        ],
        hint: "מדובר בקרבן מושלם וסופי",
        funFact: "✝️ ישוע הוא כהן גדול נצחי על סדר מלכי צדק!"
      }
    },

    25: {
      name: "הקרבנות",
      challenge: "כי אדם מכם יקריב קרבן לה'...",
      easy: {
        question: "מה היה הקרבן היומי במשכן?",
        options: [
          "קרבן השלמים",
          "עולת הבוקר והערב",
          "קרבן החטאת",
          "מנחת העוגות"
        ],
        hint: "פעמיים ביום, בוקר וערב",
        funFact: "🔥 האש על המזבח לא הייתה צריכה לכבות לעולם!"
      },
      medium: {
        question: "מה סימלה סמיכת הידיים על החיה?",
        options: [
          "הברכה",
          "העברת החטאים על הקורבן",
          "חיבה לבעל חיים",
          "הקדשה"
        ],
        hint: "מחווה של תחליף",
        funFact: "🤲 החיה מתה במקום החוטא - עקרון התחלופה!"
      },
      hard: {
        question: "כיצד הקרבנות האלה מבשרים את מעשה המשיח?",
        options: [
          "במספרם",
          "בתחלופה: התמים מת עבור האשם",
          "במחירם",
          "ביופיים"
        ],
        hint: "מדובר בעקרון התמים שתופס את מקום האשם",
        funFact: "🐑 'הוא נפצע מפשעינו, נדכא מעוונותינו'!"
      }
    },

    26: {
      name: "על גבול הארץ המובטחת",
      challenge: "אשלח מלאך לפניך, וגרשתי את הכנעני...",
      easy: {
        question: "כמה מרגלים נשלחו לחקור את הארץ המובטחת?",
        options: ["10", "12", "20", "40"],
        hint: "אחד לכל שבט של ישראל",
        funFact: "🕵️ רק 2 מתוך 12 המרגלים נתנו דוח מעודד!"
      },
      medium: {
        question: "אילו מרגלים עודדו את העם להיכנס לארץ?",
        options: [
          "אהרון ומשה",
          "יהושע וכלב",
          "גד ואשר",
          "ראובן ושמעון"
        ],
        hint: "שני אנשי אמונה שראו את הבטחות אלוהים",
        funFact: "🦁 יהושע וכלב היו היחידים מדורם שנכנסו לכנען!"
      },
      hard: {
        question: "למה ישראל נדדה 40 שנה במדבר?",
        options: [
          "כדי להענישם",
          "בגלל חוסר האמונה שלהם בהבטחות האלוהיות",
          "כדי לאמן אותם לקרב",
          "כדי למצוא את הדרך הנכונה"
        ],
        hint: "מדובר בחוסר אמון באלוהים",
        funFact: "🏜️ דור שלם נאלץ למות בגלל חוסר האמונה!"
      }
    }
  }
};

export default chapter2Translations;
